<template>
    <Modal :isOpen="isOpen" @update:isOpen="(value) => (isOpen = value)" title="Snapshot Options" size="lg" :showFooterButtons="false">
        <!-- Main Content -->
        <div class="space-y-6 mb-5">
            <!-- Topic count info -->
            <div class="text-center">
                <p class="text-sm text-muted-foreground">{{ selectedTopics.length }} topic{{ selectedTopics.length > 1 ? 's' : '' }} selected</p>
            </div>

            <!-- Option descriptions -->
            <div class="space-y-4">
                <div
                    @click="onConfigureFilters"
                    class="p-4 border rounded-lg hover:bg-accent/10 hover:border-primary/30 transition-all cursor-pointer group">
                    <h3 class="font-medium group-hover:text-primary transition-colors">Filtered Snapshot</h3>
                    <p class="text-sm text-muted-foreground mt-1">Capture only the rows you need by applying conditions to selected topics.</p>
                </div>

                <div
                    @click="onRegularSnapshot"
                    class="p-4 border rounded-lg hover:bg-accent/10 hover:border-primary/30 transition-all cursor-pointer group">
                    <h3 class="font-medium group-hover:text-primary transition-colors">Full Snapshot</h3>
                    <p class="text-sm text-muted-foreground mt-1">Capture all rows from the selected topics without applying any filters.</p>
                </div>
            </div>
        </div>

        <!-- Custom Footer with all three options -->
        <template #footer>
            <div class="flex flex-col sm:flex-row gap-3 sm:justify-end w-full">
                <Button variant="outline" @click="onCancel" class="w-full sm:w-auto"> Cancel </Button>
                <Button variant="secondary" @click="onRegularSnapshot" class="w-full sm:w-auto"> Full Snapshot </Button>
                <Button @click="onConfigureFilters" class="w-full sm:w-auto"> Filtered Snapshot </Button>
            </div>
        </template>
    </Modal>
</template>

<script setup>
import { computed } from 'vue';
import Modal from '@/components/global/modals/Modal.vue';
import { Button } from '@/components/ui/button';

const props = defineProps({
    open: {
        type: Boolean,
        default: false
    },
    selectedTopics: {
        type: Array,
        default: () => []
    }
});

const emit = defineEmits(['update:open', 'configure-filters', 'regular-snapshot', 'cancel']);

const isOpen = computed({
    get: () => props.open,
    set: (value) => emit('update:open', value)
});

// Methods
const onConfigureFilters = () => {
    emit('configure-filters');
};

const onRegularSnapshot = () => {
    emit('regular-snapshot');
};

const onCancel = () => {
    emit('cancel');
    isOpen.value = false;
};
</script>
